angular.module('aprima-provider-api').factory('SettingService',
    ['$q', 'SettingServiceTs',
        function ($q, SettingServiceTs) {
            'use strict';

            return {
                loadSettings: loadSettings,
                updateNativeSettings : updateNativeSettings,
                updatePatientDashboardConfiguration: updatePatientDashboardConfiguration,
                deletePatientDashboardConfiguration: deletePatientDashboardConfiguration,
                getSigWriterSettings: getSigWriterSettings,
                imperialUnitsAllowed: imperialUnitsAllowed,
                getPatientDashboardWidgets: getPatientDashboardWidgets,
                getAppointmentsListSettings: getAppointmentsListSettings,
                setAppointmentsListSettings: setAppointmentsListSettings,
                getMessagesListSettings: getMessagesListSettings,
                setMessagesListSettings: setMessagesListSettings,
                getAppointmentsBadgeSettings: getAppointmentsBadgeSettings,
                setAppointmentsBadgeSettings: setAppointmentsBadgeSettings,
                getDashboardTileSettings: getDashboardTileSettings,
                setDashboardTileSettings: setDashboardTileSettings,
                getKdbConfigurationId: getKdbConfigurationId,
                getKdbConfigurationIdByVisit: getKdbConfigurationIdByVisit,
                getDrugSearchIncludeInactive: getDrugSearchIncludeInactive,
            };

            function loadSettings() {
                var promise = SettingServiceTs.loadSettings();
                return $q.when(promise);
            }

            function updateNativeSettings() {
                SettingServiceTs.updateNativeSettings();
            }

            function updatePatientDashboardConfiguration(dashboardConfiguration) {
                var promise = SettingServiceTs.updatePatientDashboardConfiguration(dashboardConfiguration);
                return $q.when(promise);
            }

            function deletePatientDashboardConfiguration(dashboardConfiguration) {
                var promise = SettingServiceTs.deletePatientDashboardConfiguration(dashboardConfiguration);
                return $q.when(promise);
            }
  
            function getSigWriterSettings() {
                var promise = SettingServiceTs.getSigWriterSettings().toPromise();
                return $q.when(promise);
            }

            function imperialUnitsAllowed() {
                return SettingServiceTs.imperialUnitsAllowed();
            }

            function getPatientDashboardWidgets() {
                return SettingServiceTs.getPatientDashboardWidgets();
            }

            function getAppointmentsListSettings() {
                return SettingServiceTs.getAppointmentsListSettings();
            }

            function setAppointmentsListSettings(settings) {
                SettingServiceTs.setAppointmentsListSettings(settings);
            }

            function getMessagesListSettings() {
                return SettingServiceTs.getMessagesListSettings();
            }

            function setMessagesListSettings(settings) {
                SettingServiceTs.setMessagesListSettings(settings);
            }

            function getAppointmentsBadgeSettings() {
                return SettingServiceTs.getAppointmentsBadgeSettings();
            }

            function setAppointmentsBadgeSettings(settings) {
                SettingServiceTs.setAppointmentsBadgeSettings(settings);
            }

            function getDashboardTileSettings() {
                return SettingServiceTs.getDashboardTileSettings();
            }

            function setDashboardTileSettings(settings) {
                SettingServiceTs.setDashboardTileSettings(settings);
            }
  
            function getKdbConfigurationId(userId, renderingProviderId, billingProviderId) {
                var promise = SettingServiceTs.getKdbConfigurationId(userId, renderingProviderId, billingProviderId);
                return $q.when(promise);
            }
  
            function getKdbConfigurationIdByVisit(userId, visitId) {
                var promise = SettingServiceTs.getKdbConfigurationIdByVisit(userId, visitId);
                return $q.when(promise);
            }
  
            function getDrugSearchIncludeInactive(providerId) {
                var promise = SettingServiceTs.getDrugSearchIncludeInactive(providerId);
                return $q.when(promise);
            }
        }
    ])
;
